import { render, staticRenderFns } from "./ActionBack.vue?vue&type=template&id=6625e724&"
import script from "./ActionBack.vue?vue&type=script&lang=js&"
export * from "./ActionBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports